import type { ActionInput } from "../ActionInput.js";
import {
  hasMcaForm,
  hasTriageForm,
  incidentIsActive,
  triageSelectionIsMca,
  userIsIncidentOwner,
} from "../helpers.js";

type StartSectionMcaAction = {
  canStart: boolean;
};

type EditSectionMcaAction = {
  canEdit: boolean;
};

type SectionMcaActions = StartSectionMcaAction & EditSectionMcaAction;

function canStartMca(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    triageSelectionIsMca(actionInput)
  );
}

function canEditMca(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    hasMcaForm(actionInput)
  );
}

export function calculateMcaActions(
  actionInput: ActionInput,
): SectionMcaActions {
  return {
    canStart: canStartMca(actionInput),
    canEdit: canEditMca(actionInput),
  };
}
